import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { CompanySettings } from '@components/obsolete/settings/CompanySettings.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const CompanySettingsPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  return (
    <ResponsiveLayout title={tr('CompanySettingsPage.companySettings', 'Company settings')}>
      <CompanySettings />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(CompanySettingsPage);
